module.exports = new __parcel__URL__("InlineCreateIcon.2a8cad4b.svg").toString();